module.exports = __webpack_public_path__ + "static/media/award.e73ede8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/award.svg
// module id = 622
// module chunks = 1